<script>
import { Pie } from 'vue-chartjs'
export default {
	extends: Pie,
	props: ['data', 'options'],
	
    methods: {
        getAgeWiseUsers() {
            
                this.datacollection.labels = ["Green", "Red", "Blue"];
                this.datacollection.datasets[0].data = [1, 10, 5];
                this.renderChart(this.datacollection, {responsive: true, maintainAspectRatio: false});
        }

    },
    computed: {

    },
    mixins: [Pie],
    data(){

        return {
            is_loading: false,
            datacollection: {
                labels: ["Green", "Red", "Blue"],
                datasets: [
                  {
                    label: "Data One",
                    backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
                    data: [1, 10, 5]
                  }
                ],
            },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            
        }

    },
    mounted() {
        this.getAgeWiseUsers();   
    }
 
};
</script>